<div class="ziro-admin-page-content">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  }
  @if (!isLoading) {
    <div class="col-md-10 offset-md-1">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div [innerHTML]="'tkey;admin.email_templates.edit_view.description_header' | escapeHtml" class="mb-2"></div>
          <div [innerHTML]="'tkey;admin.email_templates.edit_view.description_text' | escapeHtml"></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
      <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
        <ziro-email-template-edit-form
          [allEmailTemplates]="emailTemplates"
          [entity]="emailTemplate"
          (ziroFormsUpdate$)="onFormUpdate($event)"
        ></ziro-email-template-edit-form>
      </ziro-collapsible-section-card>
    </div>
  }
</div>
<ziro-bottom-nav></ziro-bottom-nav>
